import { render, staticRenderFns } from "./_Branches.vue?vue&type=template&id=7d613474&"
import script from "./_Branches.vue?vue&type=script&lang=ts&"
export * from "./_Branches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports